const frPrefix = '@firstresponder.admin.ai';

export const localStore = window.localStorage;
export const authKey = `${frPrefix}:auth`;
export const shadow = 'shadow';
export const stackTable = 'stackTable';
